import { useQuery } from '@apollo/react-hooks';
import gqlTagSwag from 'graphql-tag';
import {
	boardFragment,
	epicLiteFragment,
	issueParentTypeConfigFragment,
	projectLocationFragment,
	timeTrackingOptionsFragment,
} from '../../../model/fragment/epic/index.tsx';
import type { EpicsLiteVariables as EpicsLiteQueryVariables } from './__generated_apollo__/EpicsLite.ts';
import type { EpicsLiteQueryResponse } from './types.tsx';

/**
 * Query to fetch basic epic details + configuration for the epic panel.
 */
export const EPICS_LITE_QUERY = gqlTagSwag`
    ${timeTrackingOptionsFragment}
    ${epicLiteFragment}
    ${projectLocationFragment}
    ${issueParentTypeConfigFragment}
    ${boardFragment}
    query EpicsLite($boardId: ID!, $isCompanyManaged: Boolean!) {
        jira @include(if: $isCompanyManaged) {
            timeTrackingOptions {
                ...TimeTrackingOptionsFragment
            }
        }
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents {
                edges {
                    node {
                        ...IssueParentLiteFragment
                    }
                }
            }
            board @include(if: $isCompanyManaged) {
                ...BoardFragment
            }
            projectLocation @skip(if: $isCompanyManaged) {
                ...ProjectLocationFragment
            }
        }
        globalConfig @include(if: $isCompanyManaged) {
            issueParentTypeConfig {
                ...IssueParentTypeConfigFragment
            }
        }
    }
`;

export const useEpicQueryLite = (boardId: number, isCompanyManaged: boolean) =>
	useQuery<EpicsLiteQueryResponse, EpicsLiteQueryVariables>(EPICS_LITE_QUERY, {
		skip: __SERVER__,
		context: {
			headers: {
				'is-company-managed-board': isCompanyManaged,
			},
		},
		variables: {
			boardId: String(boardId),
			isCompanyManaged,
		},
		fetchPolicy: 'network-only',
	});
